import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { Transition } from 'react-transition-group';

/**
 * FadeIn Component
 * @extends Component
 * @desc FadeIn component fades the element in over time. The finalOpacity prop determines that the opacity will be once fade-in has completed.
 *       The duration prop modifed the length of the transition.
 * @returns {Node} a FadeIn Component
 */
class FadeIn extends PureComponent {

    get defaultStyles() {
        const { duration } = this.props;
        return {
            transition: `opacity ${duration}ms ease-in-out`,
            opacity: 0
        };
    }

    get transitionStyles() {
        const { finalOpacity } = this.props;
        return {
            entering: { opacity: 0 },
            entered: { opacity: finalOpacity },
            exiting: { opacity: finalOpacity },
            exited: { opacity: 0 }
        };
    }

    render = () => {
        const { children, duration, finalOpacity, ...props } = this.props;
        return (
            <Transition in appear timeout={duration} {...props}>
                {(state) => (
                    <div
                        style={{
                            ...this.defaultStyles,
                            ...this.transitionStyles[state]
                        }}
                    >
                        {children}
                    </div>
                )}
            </Transition>
        );
    };

}

FadeIn.propTypes = {
    children: PropTypes.node.isRequired,
    duration: PropTypes.number,
    finalOpacity: PropTypes.number
};

FadeIn.defaultProps = {
    duration: 300,
    finalOpacity: 1
};

export { FadeIn };
